export default function Footer(){

    return (
        <footer className="bg-secondary-light dark:bg-primary py-6">
          <div className="container mx-auto px-4 text-center text-white dark:text-white">
            
            <p className="text-lg">&copy; All rights reserved.</p>
            <p className="text-sm mt-2 opacity-70">
              Developed by{" "}
              <a 
                href="https://github.com/schwarzam" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-100 transition-opacity underline"
              >
                schwarzam
              </a>
              {" • "}Content by{" "}
              <a 
                href="https://github.com/pedvoca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-100 transition-opacity underline"
              >
                Pedro Bessa
              </a>
            </p>

            <p className="text-sm mt-2 opacity-70">
              Organizers: Henry Best, Anupreeta More, Pedro Bessa, Margherita Grespan and Paras Sharma.
            </p>
          </div>
        </footer>
    );

}
